<script lang="ts" setup>
    import { computed } from '@vue/reactivity';
    import { DisplayStyle } from '../Enums/UiEnums';
    import MessageBadge from './Messages/MessageBadge.vue'

    const props = withDefaults(defineProps<{
            count?: number,
            zeroDisplayStyle?: DisplayStyle,
            positiveDisplayStyle?: DisplayStyle,
            negativeDisplayStyle?: DisplayStyle
        }>(), {
            zeroDisplayStyle: DisplayStyle.Secondary,
            positiveDisplayStyle: DisplayStyle.Info,
            negativeDisplayStyle: DisplayStyle.Info
    });

    const badgeDisplayStyle = computed(() =>{
        if (props.count)
        {
            if (props.count > 0)
                return props.positiveDisplayStyle;
            if (props.count < 0)
                return props.negativeDisplayStyle;
        }
        return props.zeroDisplayStyle;
    });

</script>

<template>
    <MessageBadge :displayStyle="badgeDisplayStyle">
        {{props.count}}
    </MessageBadge>
</template>